var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgChevronLeftHeader = function SvgChevronLeftHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9.601 19.199"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.053.567A1.303 1.303 0 019.085.419l.12.127a1.49 1.49 0 01.144 1.84L3.413 9.646l5.936 7.168a1.492 1.492 0 01-.144 1.84l-.12.128a1.303 1.303 0 01-2.032-.148l-6.78-8.126a1.497 1.497 0 010-1.724z",
    fill: "#fff"
  })));
};
export default SvgChevronLeftHeader;